/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./battery.vue?vue&type=template&id=2db4b265"
import script from "./battery.vue?vue&type=script&lang=js"
export * from "./battery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports